module.exports = __webpack_public_path__ + "static/media/6a.9ec2d2fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/rapeles_salto/6a.jpg
// module id = 95
// module chunks = 0